import PageHeader from "@/components/PageHeader";
import { Reveal } from "@/components/landing/Reveal";

export const inputClass =
  "w-full rounded-xl border border-white/10 bg-ink px-4 py-3.5 text-sm text-bone placeholder:text-fog/60 transition-colors duration-300 focus:border-mint focus:outline-none";
export const labelClass = "mb-1.5 block font-mono text-[10px] uppercase tracking-[0.2em] text-fog";
export const primaryBtn =
  "flex w-full items-center justify-center gap-2 rounded-full bg-mint px-6 py-3.5 text-sm font-bold text-ink transition-colors duration-300 hover:bg-bone disabled:opacity-60";

export default function AuthPage({ tag, title, sub, testid, children }) {
  return (
    <main data-testid={testid} className="min-h-screen bg-ink font-body text-bone">
      <PageHeader />
      <div className="mx-auto max-w-md px-4 py-16 sm:px-6 sm:py-20">
        <Reveal>
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-mint">{tag}</p>
          <h1 className="mt-4 font-display text-3xl font-black tracking-tight sm:text-4xl">{title}</h1>
          {sub && <p className="mt-3 text-sm leading-relaxed text-fog">{sub}</p>}
        </Reveal>
        <Reveal delay={0.1}>
          <div className="mt-8 rounded-2xl border border-white/10 bg-surface p-6 sm:p-8">{children}</div>
        </Reveal>
      </div>
    </main>
  );
}
